module.exports = __webpack_public_path__ + "img/img14.8ccc31c4.png";